import { Observer, observer } from 'mobx-react-lite';
import React, { useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaCheck, FaMinus, FaPen, FaPlus, FaTimes } from 'react-icons/fa';

import { TableDataState } from './table-paginated-v8';
import { getTableStoreFromRef } from 'store-ref';

import './table-edit-buttons.css';

// --------------------------------------------------------------------
export const TableEditButtons = observer<any>((props) => {
  const {
    canEdit,
    canInsert,
    canDelete,
    tableOptionsMeta,
    className,
    twoLines = true,
    tableStore: tableStoreProp,
    ...rest
  } = props as any;
  const tableStore = tableStoreProp ??
    getTableStoreFromRef() ?? {
      state: TableDataState.browse,
      activeRowIdx: undefined,
    };
  const { t } = useTranslation();

  const locCanInsert = () => {
    if (!canInsert) {
      return false;
    } else {
      if (tableStore.state === TableDataState.browse) return true;
      else return false;
    }
  };

  const locCanDelete = () => {
    console.log('locCanDelete tableStore.state', tableStore.state);
    if (!canDelete) {
      return false;
    } else {
      if (tableStore.state !== TableDataState.browse) return false;
      //return gridRef.current && gridRef.current.table && gridRef.current.table.row !== null;
      return tableStore.activeRowIdx !== undefined;
    }
  };

  const locCanEdit = () => {
    if (!canEdit) {
      return false;
    } else {
      if (tableStore.state !== TableDataState.browse) return false;
      //return gridRef.current && gridRef.current.table && gridRef.current.table.row !== null;
      return tableStore.activeRowIdx !== undefined;
    }
  };

  const isEditOrInsert = () => {
    return [TableDataState.edit, TableDataState.insert].includes(
      tableStore.state
    );
  };

  const btnStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
  };

  return (
    <Observer>
      {() => (
        <div className={`${className} d-flex flex-row align-items-center `}>
          <div style={{ display: 'none' }}>
            {tableStore.tableName} | {tableStore.state} |{' '}
            {tableStore.activeRowIdx ?? 'row unknown'}
          </div>

          {/* Insert - Delete - Edit Buttons */}
          <div className="d-flex flex-row">
            {/*
                 ---- Insert ----
            */}
            <Button
              className="btn-success btn-circle-lg"
              disabled={!locCanInsert()}
              onClick={() => {
                if (tableOptionsMeta) tableOptionsMeta().addNewRow();
              }}
              data-toggle="tooltip"
              data-placement="left"
              title={t('Νέα Εγγραφή')}
              style={btnStyle}
            >
              <FaPlus className="" />
            </Button>

            {/* ---- Delete ---- */}
            <Button
              className="btn-circle-lg btn-danger"
              disabled={!locCanDelete()}
              onClick={() => {
                if (tableOptionsMeta) {
                  if (tableStore.activeRowIdx !== undefined)
                    tableOptionsMeta().deleteRow(tableStore.activeRowIdx);
                }
              }}
              data-toggle="tooltip"
              data-placement="left"
              title={t('Διαγραφή Εγγραφής')}
              style={btnStyle}
            >
              <FaMinus className="" />
            </Button>

            {/* ---- Edit ---- */}
            <Button
              className="btn-circle-lg btn-warning"
              onClick={() => {
                // Edit
                if (tableOptionsMeta) {
                  if (tableStore.activeRowIdx !== undefined)
                    tableOptionsMeta().editRow(tableStore.activeRowIdx);
                }
              }}
              name="edit"
              disabled={!locCanEdit()}
              data-toggle="tooltip"
              data-placement="left"
              title={t('Επεξεργασία Εγγραφής')}
              style={btnStyle}
            >
              <FaPen color="white" className="" />
            </Button>

            {/* OK - CANCEL Same Line*/}
            {!twoLines && (
              <>
                {/*
                 ---- Save ----
            */}
                <Button
                  className="ms-1 btn-circle-lg btn-success"
                  onClick={async (e) => {
                    e.preventDefault();
                    // Save
                    if (tableOptionsMeta) await tableOptionsMeta().saveRow();
                  }}
                  name="done"
                  disabled={!isEditOrInsert()}
                  data-toggle="tooltip"
                  data-placement="left"
                  title={t('Αποθήκευση Εγγραφής')}
                  type="button"
                  style={btnStyle}
                >
                  <FaCheck />
                </Button>

                {/* ---- Cancel ---- */}
                <Button
                  className="btn-circle-lg btn-danger"
                  onClick={() => {
                    // Ακύρωση
                    if (tableOptionsMeta) tableOptionsMeta().cancelRow();
                  }}
                  name="cancel"
                  disabled={!isEditOrInsert()}
                  data-toggle="tooltip"
                  data-placement="left"
                  title={t('Ακύρωση Αλλαγών Εγγραφής')}
                  style={btnStyle}
                >
                  <FaTimes />
                </Button>
              </>
            )}
          </div>

          {/* OK - CANCEL in Line 2*/}
          {twoLines && (
            <div className="mt-3 d-flex flex-row">
              {/*
                 ---- Save ----
            */}
              <Button
                className="btn-circle-lg btn-success"
                onClick={async (e) => {
                  e.preventDefault();
                  // Save
                  if (tableOptionsMeta) await tableOptionsMeta().saveRow();
                }}
                name="done"
                disabled={!isEditOrInsert()}
                data-toggle="tooltip"
                data-placement="left"
                title={t('Αποθήκευση Εγγραφής')}
                type="button"
                style={btnStyle}
              >
                <FaCheck />
              </Button>

              {/* ---- Cancel ---- */}
              <Button
                className="ms-1 btn-circle-lg btn-danger"
                onClick={() => {
                  // Ακύρωση
                  if (tableOptionsMeta) tableOptionsMeta().cancelRow();
                }}
                name="cancel"
                disabled={!isEditOrInsert()}
                data-toggle="tooltip"
                data-placement="left"
                title={t('Ακύρωση Αλλαγών Εγγραφής')}
                style={btnStyle}
              >
                <FaTimes />
              </Button>
            </div>
          )}
        </div>
      )}
    </Observer>
  );
});
